import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/icavi-overrides.css';
import { installWebFetchBridge } from './services/core/apiClient';
import { installReactDevMeasuresCleanup } from './utils/reactDevMeasures';
installWebFetchBridge();
if (process.env.NODE_ENV !== 'production') {
    installReactDevMeasuresCleanup();
}
// Renderizar aplicação React
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(_jsx(StrictMode, { children: _jsx(App, {}) }));
}
else {
    console.error('Container root não encontrado!');
}
